import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const Street = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [street, setStreet] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setStreet(branchList?.find(branch => branch.Intern === branchId)?.Street || '')
    }
  }, [branchList?.length, branchId])

  const updateStreet = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.Street !== street) {
      updateBranch({ Street: street })
    }
  }

  return <Input label='Street' onChange={setStreet} onBlur={updateStreet} value={street} />
}
